import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, postRequest, putRequest } from '../config/axios-config';


const getAttachedPaymentMethods = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAttachedPaymentMethods
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getPlans = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getPlans
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const paymentModeSelection = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.paymentModeSelection,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getInvoices = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getInvoices
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const reSubscribeUser = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.reSubscribeUser,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const switchToAnnualPlan = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.switchToAnnualPlan,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const detachPaymentMethod = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.detachPaymentMethod,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateSubscriptionForAnnualPlan = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateSubscriptionForAnnualPlan
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateSubscriptionForQuarterlyPlan = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateSubscriptionForQuarterlyPlan
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const changeDefaultCard = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.changeDefaultCard,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updatePaymentMethod = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await putRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updatePaymentMethod,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const revertCancellationInStripe = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.revertCancellationInStripe
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getSubscriptionInfo = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getSubscriptionInfo
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const removePauseFromSubscription = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.removePauseFromSubscription
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const reSubscribeUserForSubscription = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.reSubscribeUserForSubscription,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const createPostTrackingSubscription = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createPostTrackingSubscription
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const enablePreservationPlan = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.enablePreservationPlan
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const disablePreservationPlan = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.disablePreservationPlan
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteSubscription = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.deleteSubscription
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};


const generateInvoice = (paymentId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.generateInvoice,
        { id: paymentId }
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export {
  getAttachedPaymentMethods,
  getPlans,
  paymentModeSelection,
  getInvoices,
  reSubscribeUser,
  detachPaymentMethod,
  switchToAnnualPlan,
  updateSubscriptionForAnnualPlan,
  updateSubscriptionForQuarterlyPlan,
  changeDefaultCard,
  updatePaymentMethod,
  revertCancellationInStripe,
  getSubscriptionInfo,
  removePauseFromSubscription,
  reSubscribeUserForSubscription,
  createPostTrackingSubscription,
  enablePreservationPlan,
  disablePreservationPlan,
  deleteSubscription,
  generateInvoice,
};